var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-cg",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cg-a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M-79.5 32h640v480h-640z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    clipPath: "url(#cg-a)",
    transform: "translate(79.5 -32)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M-119.5 32h720v480h-720z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00ca00",
    d: "M-119.5 32v480l480-480z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M120.5 512h480V32z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCg);
export default __webpack_public_path__ + "static/media/cg.ef7269ecc526c865724c6435ad106e8f.svg";
export { ForwardRef as ReactComponent };